<template>
  <el-tabs v-model="activeTabName" class="device-detail-tabs">
    <el-tab-pane :label="$t('Device.temperatureChart')" name="temperature">
      <Temperature
        v-if="activeTabName === 'temperature'"
        :productKey="productKey"
        :roleList="temperatureRoleList"
      />
    </el-tab-pane>
    <el-tab-pane :label="$t('Device.deviceShadow')" name="first" lazy v-if="shadowRole">
      <Shadow
        v-if="activeTabName === 'first'"
        :productKey="productKey"
        :roleList="shadowRoleList"
      />
    </el-tab-pane>
    <el-tab-pane :label="$t('Device.historyData')" name="second" lazy v-if="historyRole">
      <History v-if="activeTabName === 'second'" :productKey="productKey" />
    </el-tab-pane>
    <el-tab-pane :label="$t('Device.onlineLog')" name="third" lazy v-if="onlineRole">
      <Online v-if="activeTabName === 'third'" />
    </el-tab-pane>
    <el-tab-pane :label="$t('Device.warningRecord')" name="fourth" lazy v-if="warningRole">
      <Warning v-if="activeTabName === 'fourth'" :deviceCode="deviceCode" />
    </el-tab-pane>
    <el-tab-pane :label="$t('Device.faultRecord')" name="fiveth" lazy v-if="faultRole">
      <Fault v-if="activeTabName === 'fiveth'" :deviceCode="deviceCode" />
    </el-tab-pane>
    <el-tab-pane :label="$t('Device.connUser')" name="sixth" lazy v-if="userRole">
      <User v-if="activeTabName === 'sixth'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Shadow from './Shadow/index'
import History from './History/index'
import Online from './Online/index'
import Warning from './Warning/index'
import Fault from './Fault/index'
import User from './User/index'
import Temperature from './Temperature/index'
import { getRoleByOperationCode, getRoute } from '@/authorized'
export default {
  props: {
    productKey: {
      type: String,
      default: ''
    },
    deviceCode: {
      type: String,
      default: ''
    }
  },
  components: {
    Shadow,
    History,
    Online,
    Warning,
    Fault,
    User,
    Temperature
  },
  data() {
    return {
      activeTabName: ''
    }
  },
  created() {
    if (this.temperatureRole) {
      this.activeTabName = 'temperature'
    } else if (this.shadowRole) {
      this.activeTabName = 'first'
    } else if (this.historyRole) {
      this.activeTabName = 'second'
    } else if (this.onlineRole) {
      this.activeTabName = 'third'
    } else if (this.warningRole) {
      this.activeTabName = 'fourth'
    } else if (this.faultRole) {
      this.activeTabName = 'fiveth'
    } else if (this.userRole) {
      this.activeTabName = 'sixth'
    }
  },
  computed: {
    detailRoleList() {
      let path = '/iceDevice/list'.toLowerCase()
      let productModelRole = getRoute(path, this.$store.state.menus) || {}
      let detailRole = getRoleByOperationCode(productModelRole.childList, 'detail')
      return detailRole && detailRole.isPermission === 'Y' ? detailRole.childList : []
    },
    //temperatureRole
    temperatureRole() {
      let role = getRoleByOperationCode(this.detailRoleList, 'temperature')
      if (role) {
        let val = getRoleByOperationCode(role.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    temperatureRoleList() {
      let role = getRoleByOperationCode(this.detailRoleList, 'temperature')
      return role && role.isPermission === 'Y' ? role.childList : []
    },
    // 设备影子
    shadowRole() {
      console.log(this.detailRoleList)
      let role = getRoleByOperationCode(this.detailRoleList, 'shadow')
      if (role) {
        let val = getRoleByOperationCode(role.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    shadowRoleList() {
      let role = getRoleByOperationCode(this.detailRoleList, 'shadow')
      return role && role.isPermission === 'Y' ? role.childList : []
    },
    // 历史数据
    historyRole() {
      let role = getRoleByOperationCode(this.detailRoleList, 'history')
      if (role) {
        let val = getRoleByOperationCode(role.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    // 上下线日志
    onlineRole() {
      let role = getRoleByOperationCode(this.detailRoleList, 'online')
      if (role) {
        let val = getRoleByOperationCode(role.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    // 预警记录
    warningRole() {
      let role = getRoleByOperationCode(this.detailRoleList, 'warning')
      if (role) {
        let val = getRoleByOperationCode(role.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    // 故障记录
    faultRole() {
      let role = getRoleByOperationCode(this.detailRoleList, 'fault')
      if (role) {
        let val = getRoleByOperationCode(role.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    // 关联用户
    userRole() {
      let role = getRoleByOperationCode(this.detailRoleList, 'user')
      if (role) {
        let val = getRoleByOperationCode(role.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.device-detail-tabs {
  /deep/ {
    .el-tabs__item {
      padding: 0 !important;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      margin-right: 32px;
    }
    .el-tabs__item.is-active {
      color: $--color-blue;
      font-weight: 600;
    }
    .el-tabs__header {
      margin-bottom: 18px;
    }
  }
}
</style>
